const activeEnv = process.env.GATSBY_ACTIVE_ENV || "us"

function getLocaleShape(shape) {
  if (shape) {
    const lowerCaseShape = shape.toLowerCase()
    if (activeEnv !== "fr") {
      return shape
    }
    if (activeEnv === "fr") {
      if (lowerCaseShape === "round") return "rond"
      if (lowerCaseShape === "oval") return "ovale"
      if (lowerCaseShape === "pear") return "poire"
      if (lowerCaseShape === "cushion") return "coussin"
      if (lowerCaseShape === "marquise") return "marquise"
      if (lowerCaseShape === "elongated radiant") return "radiant allongé"
      if (lowerCaseShape === "emerald") return "émeraude"
      else {
        return shape
      }
    }
  }
}

function getLocaleCategory(category) {
  if (category) {
    const lowerCaseCategory = category.toLowerCase()
    if (activeEnv !== "fr") {
      return category
    }
    if (activeEnv === "fr") {
      if (lowerCaseCategory === "necklaces") return "Colliers"
      if (lowerCaseCategory === "earrings") return "Boucles d'oreilles"
      if (lowerCaseCategory === "rings") return "Bagues"
      if (lowerCaseCategory === "bracelets") return "Bracelets"
      if (lowerCaseCategory === "hoops") return "Créoles"
      if (lowerCaseCategory === "ear climbers")
        return "Boucles d’oreilles montantes"
      if (lowerCaseCategory === "best sellers") return "Meilleures ventes"
      if (lowerCaseCategory === "gifts") return "Cadeaux"
      if (lowerCaseCategory === "personalized") return "Personnaliser"
      else {
        return category
      }
    }
  }
}

function getLocaleOptionValues(value) {
  if (value) {
    const lowerCaseValue = value.toLowerCase()
    if (activeEnv !== "fr") {
      return value
    }
    if (activeEnv === "fr") {
      if (lowerCaseValue === "yellow gold") return "or jaune"
      if (lowerCaseValue === "rose gold") return "or rose"
      if (lowerCaseValue === "white gold") return "or blanc"
      if (lowerCaseValue === "platinum") return "platinum"
      if (lowerCaseValue === "rose gold &. yellow gold")
        return "or rose & or jaune"
      if (lowerCaseValue === "rose gold & yellow gold")
        return "or rose & or jaune"
      if (lowerCaseValue === "white gold & yellow gold")
        return "or blanc & or jaune"
      if (lowerCaseValue === "white gold & rose gold")
        return "or blanc & or rose"
      if (lowerCaseValue === "yellow gold & white gold")
        return "or blanc & or jaune"
      if (lowerCaseValue === "yellow gold & rose gold")
        return "or rose & or jaune"
      if (lowerCaseValue === "single") return "par unité"
      if (lowerCaseValue === "pair") return "par paire"
      if (lowerCaseValue === "left") return "gauche"
      if (lowerCaseValue === "right") return "droite"
      if (lowerCaseValue === "black") return "noir"
      if (lowerCaseValue === "neon pink") return "néo rose"
      if (lowerCaseValue === "dark grey") return "gris foncé"
      if (lowerCaseValue === "light grey") return "gris clair"
      if (lowerCaseValue === "navy blue") return "bleu marine"
      if (lowerCaseValue === "burgandy") return "bordeaux"
      if (lowerCaseValue === "green") return "vert"
      if (lowerCaseValue === "yellow") return "jaune"
      if (lowerCaseValue === "baby pink") return "rose pâle"
      if (lowerCaseValue === "red") return "rouge"
      if (lowerCaseValue === "blue") return "bleu"
      if (lowerCaseValue === "small") return "petit"
      if (lowerCaseValue === "medium") return "moyen"
      if (lowerCaseValue === "large") return "grand"
      if (lowerCaseValue === "decide later") return "décider plus tard"
      else {
        return value
      }
    }
  }
}

function getLocaleOptionNames(value) {
  if (value) {
    const lowerCaseValue = value.toLowerCase()
    if (activeEnv !== "fr") {
      return value
    }
    if (activeEnv === "fr") {
      if (lowerCaseValue === "size") return "taille"
      if (lowerCaseValue === "color" || lowerCaseValue === "colour")
        return "couleur"
      if (lowerCaseValue === "cord") return "corde"
      if (lowerCaseValue === "size") return "size"
      if (lowerCaseValue === "clarity") return "clareté"
      if (lowerCaseValue === "your type") return "votre type"
      else {
        return value
      }
    }
  }
}

function getLocalisedAlternatePageUrl(url, version) {
  let pageUrl = ""
  if (url) {
    pageUrl = url
    if (version === "fr") {
      if (pageUrl.includes("bespoke-engagement-ring")) {
        pageUrl = pageUrl.replace(
          "bespoke-engagement-ring",
          "bague-de-fiancailles-service-sur-mesure"
        )
      }
      if (pageUrl.includes("engagement-rings")) {
        pageUrl = pageUrl.replace("engagement-rings", "bague-de-fiancailles")
      }
      if (pageUrl.includes("wedding-rings-bands")) {
        pageUrl = pageUrl.replace("wedding-rings-bands", "alliances")
      }
    }
    if (version !== "fr") {
      if (pageUrl.includes("bague-de-fiancailles-service-sur-mesure")) {
        pageUrl = pageUrl.replace(
          "bague-de-fiancailles-service-sur-mesure",
          "bespoke-engagement-ring"
        )
      }
      if (pageUrl.includes("bague-de-fiancailles")) {
        pageUrl = pageUrl.replace("bague-de-fiancailles", "engagement-rings")
      }
      if (pageUrl.includes("alliances")) {
        pageUrl = pageUrl.replace("alliances", "wedding-rings-bands")
      }
    }
  }
  return pageUrl
}

function getLocaleContent(contents) {
  
  const filteredContent = contents.filter((content) => {
    if (activeEnv === "fr") {
      return content.node_locale === "fr"
    } else {
      return content.node_locale !== "fr"
    }
  })

  return filteredContent
}

function getIsFrance() {
  const isFrance = activeEnv === "fr"

  return isFrance
}

function getIsEU() {
  const isEU = activeEnv === "eu"

  return isEU
}

export {
  getLocaleShape,
  getLocaleCategory,
  getLocaleOptionValues,
  getLocaleOptionNames,
  getLocalisedAlternatePageUrl,
  getLocaleContent,
  getIsFrance,
  getIsEU
}
